// extracted by mini-css-extract-plugin
module.exports = {"inProgressSpan":"GuideSummaryCard_inProgressSpan__X9_ZW"};